import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { faqs } from '@/mocks/faqs';

export default function AboutPage() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, []);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '亲吻姐姐官方解析站',
    url: 'https://kissxsister-anime.com',
    description: '致力于为亲吻姐姐粉丝提供最全面、最深度的动漫内容解析与社区交流平台',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@kissxsister-anime.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 亲吻姐姐官方解析站',
    description: '了解亲吻姐姐官方解析站的品牌故事、团队理念与联系方式',
    url: 'https://kissxsister-anime.com/about',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main className="pt-20">
        <div className="px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section id="brand" className="px-4 md:px-6 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
              关于亲吻姐姐官方解析站
            </h1>
            <p className="mt-2 text-sm text-foreground-500 font-body text-center">About Us</p>

            <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900">我们的品牌故事</h2>
                <p className="mt-4 text-base text-foreground-700 font-body leading-relaxed">
                  亲吻姐姐官方解析站成立于2024年，由一群热爱亲吻姐姐这部经典恋爱动漫的资深粉丝共同创建。
                  我们致力于为全球亲吻姐姐粉丝打造一个最全面、最深度的内容解析平台。
                </p>
                <p className="mt-3 text-base text-foreground-700 font-body leading-relaxed">
                  从剧情逐集解析到角色深度剖析，从声优幕后故事到名场面回顾，我们用专业的态度和粉丝的热情，
                  为每一篇内容注入心血。我们希望每一位来到这里的粉丝，都能重新发现亲吻姐姐的魅力，
                  重温那些感动我们的瞬间。
                </p>
                <div className="flex flex-wrap gap-6 mt-6">
                  <div className="text-center">
                    <p className="text-3xl font-heading font-bold text-primary-500">100+</p>
                    <p className="text-xs text-foreground-500 font-body mt-1">深度文章</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-heading font-bold text-primary-500">50K+</p>
                    <p className="text-xs text-foreground-500 font-body mt-1">月访问量</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-heading font-bold text-primary-500">10K+</p>
                    <p className="text-xs text-foreground-500 font-body mt-1">社区粉丝</p>
                  </div>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20anime%20fan%20workspace%20with%20laptop%20displaying%20anime%20content%2C%20manga%20volumes%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20anime%20posters%20on%20wall%2C%20creative%20atmosphere%2C%20soft%20pastel%20colors%2C%20cozy%20interior&width=600&height=400&seq=about-brand&orientation=landscape"
                  alt="亲吻姐姐官方解析站 - 品牌故事"
                  title="亲吻姐姐官方解析站品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="testimonials" className="px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 text-center">粉丝口碑</h2>
            <p className="mt-2 text-sm text-foreground-600 font-body text-center">来自社区的真实评价</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10">
              {[
                {
                  name: '樱花下的约定',
                  text: '这个网站简直是亲吻姐姐粉丝的天堂！剧情解析写得非常深入，让我对这部作品有了全新的理解。特别是角色分析部分，把亚香和理香的内心世界剖析得太透彻了。',
                  role: '资深动漫迷',
                },
                {
                  name: '动漫笔记',
                  text: '作为亲吻姐姐的老粉，这个网站给出的OVA观看指南和名场面分析真的超棒。每次看都有新的感触，感谢这个平台让我重新爱上了这部作品。',
                  role: '动漫博主',
                },
                {
                  name: '二次元控',
                  text: '声优阵容的解析太专业了！竹达彩奈和佐藤聪美的配音分析让我对角色有了更深的理解。网站排版也很舒服，内容质量很高。',
                  role: '忠实粉丝',
                },
              ].map((item, i) => (
                <div key={i} className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-user-3-line text-accent-500"></i>
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-heading font-bold text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-500 font-body">{item.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 font-body leading-relaxed">{item.text}</p>
                  <div className="flex gap-1 mt-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="px-4 md:px-6 py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 text-center">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-600 font-body text-center">
              有任何问题或建议？欢迎通过以下方式联系我们
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
              <div>
                <h3 className="text-lg font-heading font-bold text-foreground-900">联系方式</h3>
                <div className="mt-5 space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-mail-line text-primary-500"></i>
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-body font-medium text-foreground-900">电子邮箱</p>
                      <p className="text-sm text-foreground-600 font-body">contact@kissxsister-anime.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-weibo-line text-primary-500"></i>
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-body font-medium text-foreground-900">官方微博</p>
                      <p className="text-sm text-foreground-600 font-body">@亲吻姐姐官方解析站</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-bilibili-line text-primary-500"></i>
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-body font-medium text-foreground-900">B站账号</p>
                      <p className="text-sm text-foreground-600 font-body">亲吻姐姐解析站</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-heading font-bold text-foreground-900">发送消息</h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 text-center">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-600 font-body text-center">FAQ</p>

            <div className="mt-10 space-y-3">
              {faqs.map((faq, index) => (
                <div key={index} className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                  <button
                    onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                    className="w-full flex items-center justify-between p-5 text-left"
                  >
                    <span className="text-sm font-body font-medium text-foreground-900 pr-4">
                      {faq.question}
                    </span>
                    <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${faqOpen === index ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-500"></i>
                    </span>
                  </button>
                  {faqOpen === index && (
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-700 font-body leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="privacy" className="px-4 md:px-6 py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl font-heading font-bold text-foreground-900 text-center">隐私政策</h2>
            <div className="mt-6 text-sm text-foreground-600 font-body leading-relaxed space-y-3">
              <p>亲吻姐姐官方解析站（以下简称"本站"）重视每一位用户的隐私保护。</p>
              <p><strong>信息收集：</strong>本站仅在用户主动订阅时收集邮箱地址，用于发送内容更新通知。我们不会收集任何其他个人信息。</p>
              <p><strong>信息使用：</strong>收集的邮箱地址仅用于发送本站内容更新，不会用于任何其他用途，也不会与第三方分享。</p>
              <p><strong>Cookie使用：</strong>本站可能使用必要的Cookie以改善浏览体验。用户可以在浏览器设置中管理Cookie偏好。</p>
              <p><strong>免责声明：</strong>本站为粉丝自制内容站点，所有关于亲吻姐姐的解析内容均为原创评论性质，与官方动画制作方无关。本站不提供任何动画资源的下载或在线观看服务。</p>
              <p>如有任何隐私相关问题，请通过上方联系方式与我们取得联系。</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      form.reset();
      return;
    }
    formData.delete('phone_alt');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9sr8mdlbrt1qcgaj8lg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const serverMsg = (parsed?.meta as Record<string, string>)?.message || (parsed as Record<string, string>)?.message || (parsed?.meta as Record<string, string>)?.detail || '';
      if (response.ok && (parsed as Record<string, string>)?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(serverMsg || '发送失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-5 space-y-4" data-readdy-form>
      <div className="honeypot-wrapper">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>
      <div>
        <input
          type="text"
          name="name"
          placeholder="你的名字"
          required
          className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-300/60 text-sm font-body text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
        />
      </div>
      <div>
        <input
          type="email"
          name="email"
          placeholder="你的邮箱"
          required
          className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-300/60 text-sm font-body text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
        />
      </div>
      <div>
        <textarea
          name="message"
          placeholder="你想说的话..."
          rows={4}
          maxLength={500}
          required
          className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-300/60 text-sm font-body text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
        ></textarea>
        <p className="text-xs text-foreground-400 font-body mt-1">最多500字</p>
      </div>
      <button
        type="submit"
        className="w-full py-3 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 font-body text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
      >
        发送消息
      </button>
      {status === 'success' && (
        <p className="text-sm text-green-600 font-body text-center">消息已发送！我们会尽快回复你。</p>
      )}
      {status === 'error' && (
        <p className="text-sm text-red-500 font-body text-center">{errorMsg}</p>
      )}
    </form>
  );
}